const names = {
  soccer_epl: 'Premier League',
  soccer_efl_champ: 'EFL Championship',
  soccer_england_efl_cup: 'EFL Cup',
  soccer_uefa_champs_league: 'Champions League',
  soccer_uefa_champs_league_qualification: 'Champions League Qualifying',
  soccer_spain_la_liga: 'La Liga',
  soccer_germany_bundesliga: 'Bundesliga',
  soccer_italy_serie_a: 'Serie A',
  soccer_france_ligue_one: 'Ligue 1',
  soccer_fifa_world_cup: 'FIFA World Cup',
  soccer_uefa_nations_league: 'UEFA Nations League',
};

export default function leagueName(keys) {
  const leagues = [...new Set((Array.isArray(keys) ? keys : String(keys || '').split(',')).filter(Boolean))];
  return leagues.length ? leagues.map((key) => names[key] || key).join(' / ') : 'League not recorded';
}
